import { FC } from 'react'

type ValidatorRef = { validationType: string; value: Record<string, unknown> }

interface TextAreaFieldProps {
  value?: string | null
  disabled?: boolean
  handleResponse: (value: string) => void
  // Props below exist for interface consistency with other field types
  variant?: string
  handleSearch?: (value: string) => void
  options?: unknown[]
  loading?: boolean
  isMultiple?: boolean
  numPad?: boolean
  questionDisplay?: string | null
  valueRef?: unknown
  validatorsRef?: ValidatorRef[]
  patternError?: string | null
  onPatternError?: (error: string | null) => void
}

const TextAreaField: FC<TextAreaFieldProps> = ({
  handleResponse,
  value,
  disabled = false,
  patternError,
}) => {
  const inputValue = value === null || value === undefined ? '' : value

  // Validation and branching are driven by the server; this field only renders
  // the input and any server-provided error passed via `patternError`.
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    handleResponse(e.target.value)
  }

  return (
    <div>
      <textarea
        disabled={disabled}
        value={inputValue}
        onChange={handleChange}
        rows={4}
        className="w-full rounded-md border border-border-strong px-3 py-2 text-sm shadow-sm placeholder:text-text-tertiary focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:bg-surface-hover"
      />
      {patternError && <p className="mt-1 text-sm text-error">{patternError}</p>}
    </div>
  )
}

export default TextAreaField
